<template>
  <AuthForm />
</template>
<script setup lang="ts">
  useHead({ title: 'Log In | Yogen' })
</script>
